import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  IconButton,
  Collapse,
  Button,
  Grid,
} from "@mui/material";

// Header Styles
export const HeaderBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: theme.spacing(0, 2),
}));

export const MappingIndexTypography = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 700,
  color: "#000000",
}));

export const ToggleButton = styled(IconButton)(({ theme }) => ({
  color: "#00A67E",
  "&:hover": {
    backgroundColor: "rgba(0, 166, 126, 0.04)",
  },
}));

export const MappingRuleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 12,
  color: "rgb(13, 75, 191)",
  padding: theme.spacing(0, 2),
}));

// Collapse Styles
export const StyledCollapse = styled(Collapse)(({ theme }) => ({
  border: "1px solid #EAEAEA",
  margin: "14px",
}));

// Content Styles
export const ContentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const HeaderGrid = styled(Grid)(({ theme }) => ({
  // justifyContent: "space-between",
}));

export const HeaderGridTop = styled(Grid)(({ theme }) => ({
  width: "100%",
  display: "flex",
  justifyContent: " space-between",
  alignItems: "center",
}));

export const HeaderGridBottom = styled(Grid)(({ theme }) => ({
  // width: "100%",
  // display: "flex",
  // justifyContent: " space-between",
  // alignItems: "center",
  // marginBottom: theme.spacing(0.5),
}));

export const FooterGridBottom = styled(Grid)(({ theme }) => ({
  margin: theme.spacing(2),
}));

export const SectionLabelTypography = styled(Typography)(({ theme }) => ({
  fontSize: "10px",
  fontWeight: 500,
  color: "#777777",
  textTransform: "uppercase",
}));

export const MappingRuleNote = styled(Typography)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 500,
  color: "#555555",
  // margin: theme.spacing(0.5),
  // textTransform: "uppercase",
}));

export const DuplicateButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(1),
  color: "#00A67E",
  "&:hover": {
    backgroundColor: "rgba(0, 166, 126, 0.04)",
  },
}));

export const LabProductInfoContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginTop: theme.spacing(0.5),
}));

export const ProductNameTypography = styled(Typography)(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  color: "#1A1A1A",
}));

export const ProductTypeTypography = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  color: "#757575",
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
}));

export const RemoveText = styled(Typography)(({ theme }) => ({
  fontSize: "13px",
  fontWeight: 500,
  color: "#E33946",
  marginLeft: theme.spacing(0.5),
  cursor: "pointer",
}));

export const ProductPriceTypography = styled(Typography)(({ theme }) => ({
  
  fontSize: "16px",
  fontWeight: 500,
  color: "#FF6B00",
}));

// Dentira Equivalent Styles
export const EquivalentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

export const EmptyEquivalentBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#FDFCFA",
}));

export const EquivalentLabelTypography = styled(Typography)(({ theme }) => ({
  
  fontSize: "12px",
  fontWeight: 500,
  color: "#777777",
  textTransform: "uppercase",
  marginBottom: theme.spacing(1),
}));

export const EquivalentNameTypography = styled(Typography)(({ theme }) => ({
  
  fontSize: "14px",
  color: "#1A1A1A",
}));

export const EquivalentDescriptionTypography = styled(Typography)(
  ({ theme }) => ({
    
    fontSize: "14px",
    color: "#757575",
  })
);

export const EquivalentProductLabel = styled(Typography)(
  ({ theme }) => ({
    
    fontSize: "14px",
    color: "#777777",
  })
);

export const EmptyEquivalentTypography = styled(Typography)(({ theme }) => ({
  
  fontSize: "14px",
  color: "#757575",
}));

export const EquivalentPriceTypography = styled(Typography)(({ theme }) => ({
  
  fontSize: "14px",
  fontWeight: 500,
  color: "#FF6B00",
  marginTop: theme.spacing(1),
}));

// Divider Styles
export const StyledDivider = styled("div")(({ theme }) => ({
  margin: theme.spacing(1),
}));

// Image Container Styles
export const LinkImageContainer = styled("img")(({ theme }) => ({
  position: "absolute",
  right: "25%",
  marginTop: "-28px",
}));
